(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports"], b);else if ("undefined" != typeof exports) b(exports);else {
    var c = {
      exports: {}
    };
    b(c.exports), a.compose = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a) {
  "use strict";

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;

  a.default = function () {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    return 0 === a.length ? function (a) {
      return a;
    } : 1 === a.length ? a[0] : a.reduce(function (c, a) {
      return function () {
        return c(a.apply(void 0, arguments));
      };
    });
  };
});